"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReportingEmotionsTemplate = exports.ReportingEmotions = exports.GoalMetric = exports.ReportingFilterField = exports.ReportingFilterOperator = exports.ReportingTransactionProperties = exports.ReportingGoalMetric = exports.CampaignStatisticsStatus = exports.GetNpsFeedbacksSortDir = exports.GetNpsFeedbacksSortField = exports.ReportingResponseStatus = exports.REPORT_COPILOT_INDEX = exports.REPORT_COPILOT_TREND = void 0;
var REPORT_COPILOT_TREND;
(function (REPORT_COPILOT_TREND) {
    REPORT_COPILOT_TREND["BAD"] = "BAD";
    REPORT_COPILOT_TREND["BALANCED"] = "BALANCED";
    REPORT_COPILOT_TREND["GREAT"] = "GREAT";
})(REPORT_COPILOT_TREND = exports.REPORT_COPILOT_TREND || (exports.REPORT_COPILOT_TREND = {}));
var REPORT_COPILOT_INDEX;
(function (REPORT_COPILOT_INDEX) {
    REPORT_COPILOT_INDEX["PRE_READINESS"] = "PRE_READINESS";
    REPORT_COPILOT_INDEX["SUPER_LOSER"] = "SUPER_LOSER";
    REPORT_COPILOT_INDEX["LOSER"] = "LOSER";
    REPORT_COPILOT_INDEX["NEUTRAL"] = "NEUTRAL";
    REPORT_COPILOT_INDEX["MORE_DATA"] = "MORE_DATA";
    REPORT_COPILOT_INDEX["OPPOSITE"] = "OPPOSITE";
    REPORT_COPILOT_INDEX["WINNER"] = "WINNER";
    REPORT_COPILOT_INDEX["SUPER_WINNER"] = "SUPER_WINNER";
})(REPORT_COPILOT_INDEX = exports.REPORT_COPILOT_INDEX || (exports.REPORT_COPILOT_INDEX = {}));
var ReportingResponseStatus;
(function (ReportingResponseStatus) {
    ReportingResponseStatus["PENDING"] = "PENDING";
    ReportingResponseStatus["PROCESSING"] = "PROCESSING";
    ReportingResponseStatus["SUCCESS"] = "SUCCESS";
    ReportingResponseStatus["FAILED"] = "FAILED";
})(ReportingResponseStatus = exports.ReportingResponseStatus || (exports.ReportingResponseStatus = {}));
var GetNpsFeedbacksSortField;
(function (GetNpsFeedbacksSortField) {
    GetNpsFeedbacksSortField["Score"] = "score";
    GetNpsFeedbacksSortField["Date"] = "date";
})(GetNpsFeedbacksSortField = exports.GetNpsFeedbacksSortField || (exports.GetNpsFeedbacksSortField = {}));
var GetNpsFeedbacksSortDir;
(function (GetNpsFeedbacksSortDir) {
    GetNpsFeedbacksSortDir["Asc"] = "asc";
    GetNpsFeedbacksSortDir["Desc"] = "desc";
})(GetNpsFeedbacksSortDir = exports.GetNpsFeedbacksSortDir || (exports.GetNpsFeedbacksSortDir = {}));
var CampaignStatisticsStatus;
(function (CampaignStatisticsStatus) {
    CampaignStatisticsStatus["PROCESSING"] = "processing";
    CampaignStatisticsStatus["NOT_SCHEDULED"] = "not_scheduled";
})(CampaignStatisticsStatus = exports.CampaignStatisticsStatus || (exports.CampaignStatisticsStatus = {}));
var ReportingGoalMetric;
(function (ReportingGoalMetric) {
    ReportingGoalMetric["TRANSACTION_REVENUE"] = "transactionRevenue";
    ReportingGoalMetric["POTENTIAL_REVENUE"] = "potentialRevenue";
    ReportingGoalMetric["PAGE_VIEWS_PER_SESSION"] = "pageviewsPerSession";
    ReportingGoalMetric["REVENUE_PER_TRANSACTION"] = "revenuePerTransaction";
    ReportingGoalMetric["REVENUE_PER_USER"] = "revenuePerUser";
    ReportingGoalMetric["UNIQUE_PAGE_VIEWS"] = "uniquePageviews";
    ReportingGoalMetric["PAGE_VIEWS"] = "pageviews";
    ReportingGoalMetric["UNIQUE_TRANSACTIONS"] = "uniqueTransactions";
    ReportingGoalMetric["TRANSACTIONS"] = "transactions";
    ReportingGoalMetric["ITEMS_QUANTITY"] = "itemsQuantity";
    ReportingGoalMetric["REVISIT_RATE"] = "revisitRate";
    ReportingGoalMetric["UNIQUE_EVENTS"] = "uniqueEvents";
    ReportingGoalMetric["TOTAL_EVENTS"] = "totalEvents";
    ReportingGoalMetric["BOUNCE_RATE"] = "bounceRate";
})(ReportingGoalMetric = exports.ReportingGoalMetric || (exports.ReportingGoalMetric = {}));
var ReportingTransactionProperties;
(function (ReportingTransactionProperties) {
    ReportingTransactionProperties["ShippingMethods"] = "shippingMethods";
    ReportingTransactionProperties["PaymentMethods"] = "paymentMethods";
    ReportingTransactionProperties["Currencies"] = "currencies";
    ReportingTransactionProperties["CustomVariableNames"] = "customVariableNames";
    ReportingTransactionProperties["ProductCategories"] = "productCategories";
    ReportingTransactionProperties["Affiliations"] = "affiliations";
})(ReportingTransactionProperties = exports.ReportingTransactionProperties || (exports.ReportingTransactionProperties = {}));
var ReportingFilterOperator;
(function (ReportingFilterOperator) {
    ReportingFilterOperator["EQUAL"] = "EQUAL";
    ReportingFilterOperator["NOT_EQUAL"] = "NOT_EQUAL";
    ReportingFilterOperator["AND"] = "AND";
    ReportingFilterOperator["OR"] = "OR";
    ReportingFilterOperator["CONTAINS"] = "CONTAINS";
    ReportingFilterOperator["NOT_CONTAINS"] = "NOT_CONTAINS";
    ReportingFilterOperator["REGEXP"] = "REGEXP";
    ReportingFilterOperator["GREATER"] = "GREATER";
    ReportingFilterOperator["LESS"] = "LESS";
    ReportingFilterOperator["BETWEEN"] = "BETWEEN";
    ReportingFilterOperator["IS_NULL"] = "IS_NULL";
    ReportingFilterOperator["IS_NOT_NULL"] = "IS_NOT_NULL";
})(ReportingFilterOperator = exports.ReportingFilterOperator || (exports.ReportingFilterOperator = {}));
var ReportingFilterField;
(function (ReportingFilterField) {
    ReportingFilterField["DEVICE"] = "device";
    ReportingFilterField["BROWSER"] = "browser";
    ReportingFilterField["IS_NEW_VISITOR"] = "isNewVisitor";
    ReportingFilterField["EVENT_CATEGORY"] = "eventCategory";
    ReportingFilterField["EVENT_ACTION"] = "eventAction";
    ReportingFilterField["EVENT_LABEL"] = "eventLabel";
    ReportingFilterField["EVENT_VALUE"] = "eventValue";
    ReportingFilterField["IS_ENTRANCE"] = "isEntrance";
    ReportingFilterField["COUNTRY"] = "country";
    ReportingFilterField["REGION"] = "region";
    ReportingFilterField["CITY"] = "city";
    ReportingFilterField["SEGMENT_KEY"] = "segmentKey";
    ReportingFilterField["SEGMENT_VALUE"] = "segmentValue";
    ReportingFilterField["ITEM_REVENUE"] = "itemRevenue";
    ReportingFilterField["ITEM_QUANTITY"] = "itemQuantity";
    ReportingFilterField["ITEM_COUNT"] = "itemCount";
    ReportingFilterField["ITEM_SKU"] = "productSku";
    ReportingFilterField["ITEM_NAME"] = "productName";
    ReportingFilterField["PRODUCT_CATEGORY"] = "productCategory";
    ReportingFilterField["TRANSACTION_REVENUE"] = "transactionRevenue";
    ReportingFilterField["TRANSACTION_SHIPPING"] = "transactionShipping";
    ReportingFilterField["TRANSACTION_TAX"] = "transactionTax";
    ReportingFilterField["PAYMENT_METHOD"] = "paymentMethod";
    ReportingFilterField["SHIPPING_METHOD"] = "shippingMethod";
    ReportingFilterField["CURRENCY_CODE"] = "currencyCode";
    ReportingFilterField["TRANSACTION_ID"] = "transactionId";
    ReportingFilterField["TRANSACTION_COUPON"] = "transactionCoupon";
    ReportingFilterField["AFFILIATION"] = "affiliation";
    ReportingFilterField["CUSTOM_VAR_NAME"] = "customVarName";
    ReportingFilterField["CUSTOM_VAR_VALUE"] = "customVarValue";
    ReportingFilterField["CUSTOM_VAR_INDEX"] = "customVarIndex";
    ReportingFilterField["DATA_INTEGRATION_SEGMENT_KEY"] = "segmentKey";
    ReportingFilterField["DATA_INTEGRATION_SEGMENT_VALUE"] = "segmentValue";
    ReportingFilterField["PARTNER"] = "partner";
})(ReportingFilterField = exports.ReportingFilterField || (exports.ReportingFilterField = {}));
var GoalMetric;
(function (GoalMetric) {
    GoalMetric["ACTION_TRACKING"] = "uniqueEvents";
    GoalMetric["ACTION_TRACKING_MULTIPLE"] = "totalEvents";
    GoalMetric["TRANSACTION"] = "uniqueTransactions";
    GoalMetric["TRANSACTION_REVENUE"] = "transactionsRevenue";
    GoalMetric["TRANSACTION_ORDER_DETAILS"] = "revenuePerTransaction";
    GoalMetric["BOUNCE_RATE"] = "bounces";
    GoalMetric["REVISIT"] = "revisits";
    GoalMetric["PAGE_VIEW"] = "uniquePageviews";
    GoalMetric["PAGE_VIEW_MULTIPLE"] = "pageviews";
})(GoalMetric = exports.GoalMetric || (exports.GoalMetric = {}));
var ReportingEmotions;
(function (ReportingEmotions) {
    ReportingEmotions["Attention"] = "attention";
    ReportingEmotions["Change"] = "change";
    ReportingEmotions["Comfort"] = "comfort";
    ReportingEmotions["Community"] = "community";
    ReportingEmotions["Competition"] = "competition";
    ReportingEmotions["Immediacy"] = "immediacy";
    ReportingEmotions["Notoriety"] = "notoriety";
    ReportingEmotions["Quality"] = "quality";
    ReportingEmotions["Safety"] = "safety";
    ReportingEmotions["Understanding"] = "understanding";
})(ReportingEmotions = exports.ReportingEmotions || (exports.ReportingEmotions = {}));
var ReportingEmotionsTemplate;
(function (ReportingEmotionsTemplate) {
    ReportingEmotionsTemplate["Combined"] = "all";
    ReportingEmotionsTemplate["Desktop"] = "desktop";
    ReportingEmotionsTemplate["Mobile"] = "mobile";
})(ReportingEmotionsTemplate = exports.ReportingEmotionsTemplate || (exports.ReportingEmotionsTemplate = {}));
__exportStar(require("./feedbackAnalysis/types"), exports);
//# sourceMappingURL=types.js.map